/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Midline2D } from './Midline2D';
import {
    Midline2DFromJSON,
    Midline2DFromJSONTyped,
    Midline2DToJSON,
    Midline2DToJSONTyped,
} from './Midline2D';
import type { ServerLengthModelVariant } from './ServerLengthModelVariant';
import {
    ServerLengthModelVariantFromJSON,
    ServerLengthModelVariantFromJSONTyped,
    ServerLengthModelVariantToJSON,
    ServerLengthModelVariantToJSONTyped,
} from './ServerLengthModelVariant';
import type { ServerLengthFrameSchema } from './ServerLengthFrameSchema';
import {
    ServerLengthFrameSchemaFromJSON,
    ServerLengthFrameSchemaFromJSONTyped,
    ServerLengthFrameSchemaToJSON,
    ServerLengthFrameSchemaToJSONTyped,
} from './ServerLengthFrameSchema';
import type { ServerLengthStatus } from './ServerLengthStatus';
import {
    ServerLengthStatusFromJSON,
    ServerLengthStatusFromJSONTyped,
    ServerLengthStatusToJSON,
    ServerLengthStatusToJSONTyped,
} from './ServerLengthStatus';

/**
 * Server-side (Fishial) length recompute, surfaced next to the on-net
 * `length_millimeters` for side-by-side comparison in the catch panel.
 * @export
 * @interface ServerLengthSchema
 */
export interface ServerLengthSchema {
    /**
     * 
     */
    status: ServerLengthStatus;
    /**
     * 
     */
    modelVariant: ServerLengthModelVariant;
    /**
     * 
     */
    lengthMillimeters: number | null;
    /**
     * 
     */
    confidence: number | null;
    /**
     * 
     */
    chosenFrameIndex: number | null;
    /**
     * 
     */
    maskUrl: string | null;
    /**
     * 
     */
    midline: Midline2D | null;
    /**
     * 
     */
    frames: Array<ServerLengthFrameSchema>;
}



/**
 * Check if a given object implements the ServerLengthSchema interface.
 */
export function instanceOfServerLengthSchema(value: object): value is ServerLengthSchema {
    if (!('status' in value) || value['status'] === undefined) return false;
    if ((!('modelVariant' in (value as Record<string, any>)) && !('model_variant' in (value as Record<string, any>))) || ((value as Record<string, any>)['modelVariant'] === undefined && (value as Record<string, any>)['model_variant'] === undefined)) return false;
    if ((!('lengthMillimeters' in (value as Record<string, any>)) && !('length_millimeters' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthMillimeters'] === undefined && (value as Record<string, any>)['length_millimeters'] === undefined)) return false;
    if (!('confidence' in value) || value['confidence'] === undefined) return false;
    if ((!('chosenFrameIndex' in (value as Record<string, any>)) && !('chosen_frame_index' in (value as Record<string, any>))) || ((value as Record<string, any>)['chosenFrameIndex'] === undefined && (value as Record<string, any>)['chosen_frame_index'] === undefined)) return false;
    if ((!('maskUrl' in (value as Record<string, any>)) && !('mask_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['maskUrl'] === undefined && (value as Record<string, any>)['mask_url'] === undefined)) return false;
    if (!('midline' in value) || value['midline'] === undefined) return false;
    if (!('frames' in value) || value['frames'] === undefined) return false;
    return true;
}

export function ServerLengthSchemaFromJSON(json: any): ServerLengthSchema {
    return ServerLengthSchemaFromJSONTyped(json, false);
}

export function ServerLengthSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServerLengthSchema {
    if (json == null) {
        return json;
    }
    return {
        
        'status': ServerLengthStatusFromJSON(json['status']),
        'modelVariant': ServerLengthModelVariantFromJSON(json['model_variant']),
        'lengthMillimeters': json['length_millimeters'],
        'confidence': json['confidence'],
        'chosenFrameIndex': json['chosen_frame_index'],
        'maskUrl': json['mask_url'],
        'midline': Midline2DFromJSON(json['midline']),
        'frames': ((json['frames'] as Array<any>).map(ServerLengthFrameSchemaFromJSON)),
    };
}

export function ServerLengthSchemaToJSON(json: any): ServerLengthSchema {
    return ServerLengthSchemaToJSONTyped(json, false);
}

export function ServerLengthSchemaToJSONTyped(value?: ServerLengthSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': ServerLengthStatusToJSON(value['status']),
        'model_variant': ServerLengthModelVariantToJSON(value['modelVariant']),
        'length_millimeters': value['lengthMillimeters'],
        'confidence': value['confidence'],
        'chosen_frame_index': value['chosenFrameIndex'],
        'mask_url': value['maskUrl'],
        'midline': Midline2DToJSON(value['midline']),
        'frames': ((value['frames'] as Array<any>).map(ServerLengthFrameSchemaToJSON)),
    };
}

